import { createSelector } from 'reselect';

import getMenuWithDiscounts from './getMenuWithDiscounts';

const getMenuProducts = createSelector(
  getMenuWithDiscounts,
  menu =>
    (menu &&
      menu.sections.reduce((products, section) => {
        const sectionProducts = section.products.reduce((acc, product) => {
          const x = {
            ...product,
            section: {
              name: section.name,
            },
          };
          return [...acc, x];
        }, []);

        return [...products, ...sectionProducts];
      }, [])) ||
    [],
);

export default getMenuProducts;
